import { render, staticRenderFns } from "./StatisticsProduction.vue?vue&type=template&id=5c1f5e32&"
import script from "./StatisticsProduction.vue?vue&type=script&lang=js&"
export * from "./StatisticsProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports